import { useQuery } from "react-query";
import { getQualityQuestions } from "api/Customers";

interface FiltersProps {
    search?: string,
}
export const useQualityCheckQuestions = (filters?: FiltersProps) => {
  return useQuery(
    ["quality-questions", filters?.search,],
    () => getQualityQuestions({
            search: filters?.search,
          }),
    {
      onError(error: any) {
        console.error(error);
      }
    }
  );
};
